import { render, staticRenderFns } from "./paneConfig.vue?vue&type=template&id=cf231b7e&scoped=true"
import script from "./paneConfig.vue?vue&type=script&lang=js"
export * from "./paneConfig.vue?vue&type=script&lang=js"
import style0 from "./paneConfig.vue?vue&type=style&index=0&id=cf231b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf231b7e",
  null
  
)

export default component.exports